import {
  DROPDOWN,
  DropdownDefinition,
  ItemIds,
  LAYOUT_COLUMNS,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  QUIZ_TEXT_FILL,
  TEXT,
  QUIZ_CHOICE
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { ItemDefinition } from '~/training/sequence/templates/items/Item';
import { ItemOfType } from '~/training/sequence/templates/translators/itemHelpers/types';
import { useEditorStore } from '~/shell/Store';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import { detectMultiSelect } from '~/training/sequence/templates/translators/itemHelpers/Quiz';

export const Quiz3: Translator = sequence => {
  const { editorMode } = useEditorStore.getState();

  const CardElement = sequence.items?.find(
    item => item.__typename == 'Card'
  ) as ItemOfType<'Card'>;

  const incorrectFeedbackAudios =
    CardElement && CardElement.audios ? CardElement.audios : false;

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question': {
        const dropDownItems: Array<DropdownDefinition> = [];

        (item?.items || []).forEach((item, index) => {
          dropDownItems.push({
            label: item.value,
            correct: item.correct,
            feedback: item.feedback,
            feedbackAudios: item.feedbackAudios,
            incorrectFeedbackAudios: incorrectFeedbackAudios,
            id: index,
            questionId: item.id
          } as DropdownDefinition);
        });

        const arrayWithItems: ItemDefinition<ItemIds>[] = [];

        if (editorMode) {
          arrayWithItems.push({
            type: TEXT,
            id: `${item.id}_body`,
            items: [],
            values: {
              value: item?.body,
              showQuizDropdown: true
            }
          });

          arrayWithItems.push({
            type: QUIZ_CHOICE,
            id: `${item.id}_choice`,
            items: AnswerButtonHelper({
              group: null,
              items: item.items,
              linkedAudioId: undefined,
              llamaSurvey: item.llamaSurvey,
              question: item.title || '',
              correctAnswers: item.items ? detectMultiSelect(item.items) : [],
              disableButtons: true
            }),
            values: {
              value: item?.body,
              disableButtons: true
            }
          });
        } else {
          const arrayWithChunks = item?.body
            ?.replace('<p>', '')
            ?.replace('</p>\\n', '')
            .split('XXX');

          const arrayLength =
            arrayWithChunks && arrayWithChunks.length
              ? arrayWithChunks.length
              : 0;

          (arrayWithChunks || []).forEach((data, index) => {
            if (index != arrayLength) {
              if (data) {
                arrayWithItems.push({
                  type: TEXT,
                  id: `text_${index}`,
                  items: [],
                  values: {
                    value: data
                  }
                });
              }
            }

            if (index != arrayLength - 1) {
              arrayWithItems.push({
                type: DROPDOWN,
                id: `dropdown_${index}_${item.id}`,
                values: {},
                items: []
              });
            }

            if (data.includes('.') && index == arrayLength) {
              arrayWithItems.push({
                type: TEXT,
                id: `text_dot`,
                items: [],
                values: {
                  value: '.'
                }
              });
            }
          });
        }

        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            {
              type: LAYOUT_COLUMNS,
              id: '1',
              values: {},
              items: [
                {
                  id: item.id,
                  type: LAYOUT_LIST,
                  values: { align: 'left' },
                  items: [
                    {
                      type: TEXT,
                      id: `${item.id}_subtitle`,
                      items: [],
                      values: {
                        value: item.subtitle,
                        variant: 'sub_heading',
                        icon: item?.icon || ''
                      }
                    },
                    {
                      type: TEXT,
                      id: `${item.id}_title`,
                      items: [],
                      values: {
                        value: item.title,
                        variant: 'heading1'
                      }
                    },
                    {
                      type: QUIZ_TEXT_FILL,
                      id: '1',
                      values: {
                        dropdownItems: dropDownItems
                      },
                      items: arrayWithItems
                    }
                  ]
                } as LayoutListDefinition
              ]
            }
          ]
        } as LayoutHalfPageDefinition;
      }
      default:
        return null;
    }
  });
};
